import { createContext } from 'react';
import Addon from '../../../classes/addon';
import Channel from '../../../classes/channel';

const AddonContext = createContext<{
  addon: Addon | null;
  channels: Channel[] | null;
  error?: boolean;
}>({
  addon: null,
  channels: null,
  error: false,
});

export default AddonContext;
